import {
  removeAllVuePreloadHiddenClasses,
  removeAllVuePostloadHiddenElements
} from './util';

import './components/payment';

removeAllVuePreloadHiddenClasses('#as_payment');
removeAllVuePostloadHiddenElements('#as_payment');
